/**
 * The mobile shell scrolls the document (desktop lays out in inner-scrolling
 * columns, so the window barely moves there). Without this, an SPA
 * navigation keeps the Library's scroll offset and the transcript opens
 * mid-page. Back/forward restores the saved position so returning to the
 * Library lands where the user left off.
 */
export function shellScrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }
  return { top: 0, left: 0 };
}
